module.exports = __webpack_public_path__ + "images/category_lp/watch/case2_1054a410b1d974153c4f3613e6b32039.jpg";